import React from 'react'
import styled from 'styled-components'
import themeGet from '@fuegokit/react/utils/theme-get'
import sx, {SxProp} from '@fuegokit/react/sx'
import {LabelProps} from './types'

const labelStyles = {
  display: 'grid',
  gridAutoColumns: '1fr',
  gridAutoRows: 'min-content',
  color: 'text.default',
  cursor: 'default',
  fontFamily: 'normal'
}

const textLabelLayoutStyles = {
  gap: '0px 4px',
  gridTemplateColumns: 'min-content auto'
}

const disabledStyles = {
  color: themeGet('colors.text.disabled'),
  cursor: 'not-allowed'
}

const StyledLabel = styled.label<LabelProps & SxProp>`
  font-size: ${p => {
    if (p.labelSize === 'default') return themeGet('fontSizes.3')
    if (p.labelSize === 'small') return '12px'
    return 'revert'
  }};
  ${sx}
`

export const AtlasCheckboxLabel = ({
  children,
  isDisabled,
  testId,
  onClick,
  label,
  labelSize = 'default',
  id
}: LabelProps) => {
  if (!label) return null

  return (
    <StyledLabel
      sx={{...labelStyles, ...textLabelLayoutStyles}}
      data-testid={testId ? `${testId}-checkbox-label` : undefined}
      data-disabled={isDisabled || undefined}
      onClick={onClick}
      labelSize={labelSize}
      id={id}
    >
      {children}
    </StyledLabel>
  )
}
